export const PINS = ["184803", "701111", "648096", "932043", "817042", "119516", "662065", "045808", "845133"]
